import React from 'react';
import { object, bool } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import HeaderComponent from './HeaderContainer';
import SideBar from './SidebarComponent';
import * as media from '../styles/media-queries';
import { isLoggedIn } from '../../services/authService';
import SimpleHeader from './SimpleHeader';

const styles = (theme) => ({
  root: {
    display: 'flex',
    ...media.hideOnPrint
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: 15,
    ...media.xSmallScreen({
      marginLeft: -50
    })
  }
});

class BarsComponent extends React.Component {
  state = {
    open: false
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, location, headerNoRedux, noSidebar } = this.props;
    const { open } = this.state;
    const routesWithoutSideBar = [`/error`, '/login'];
    const hasSideBar = !routesWithoutSideBar.some((route) => route == location.pathname);
    const routesWithoutHeader = [`/error`];
    const simpleHeader = routesWithoutHeader.some((route) => route == location.pathname);

    return (
      <div className={classes.root}>
        {/**
          Page
          The <html> and <body> elements are updated to provide better page-wide defaults. More specifically:

          The margin in all browsers is removed.
          The default Material Design background color is applied. It's using theme.palette.background.default for standard devices and a white background for print devices.
          Layout
          box-sizing is set globally on the <html> element to border-box. Every element—including *::before and *::after are declared to inherit this property, which ensures that the declared width of the element is never exceeded due to padding or border.
          Typography
          Font antialiasing is enabled for better display of the Roboto font.
          No base font-size is declared on the <html>, but 16px is assumed (the browser default). You can learn more about the implications of changing the <html> default font size in the theme documentation page. 
        */}
        <CssBaseline />
        {headerNoRedux ? (
          <SimpleHeader />
        ) : (
          <HeaderComponent
            handleDrawerOpen={this.handleDrawerOpen}
            openDrawer={open}
            simpleHeader={simpleHeader}
          />
        )}

        {isLoggedIn() && hasSideBar && !noSidebar && (
          <SideBar
            handleDrawerOpen={this.handleDrawerOpen}
            handleDrawerClose={this.handleDrawerClose}
            openDrawer={open}
            location={location}
          />
        )}
      </div>
    );
  }
}

BarsComponent.propTypes = {
  classes: object,
  children: object,
  location: object,
  history: object,
  headerNoRedux: bool,
  noSidebar: bool
};

export default withStyles(styles)(BarsComponent);
